import { call, put, takeEvery } from 'redux-saga/effects'
import { fetchPaymentEligibility } from 'services/api/elegible'

import * as actions from './actions'
import { FetchElegiblePMsAction } from './actions'
import { FETCH_ELEGIBLE_PMS_TYPE } from './actionTypes'

const fetchElegiblePMsSaga = function* (action: FetchElegiblePMsAction) {
  const {
    payload: { currency }
  } = action
  yield put(actions.setFetchingElegiblePMs(currency, true))
  const data = yield call(fetchPaymentEligibility, currency)

  if (data.error) {
    return yield put(actions.setFetchElegiblePMsError(currency, data.error))
  }

  yield put(actions.setElegiblePMs(currency, data.response))
  yield put(actions.setFetchingElegiblePMs(currency, false))
}

export default function* methodsSagas() {
  yield takeEvery(FETCH_ELEGIBLE_PMS_TYPE, fetchElegiblePMsSaga)
}
